import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Loading from "../Components/Loading";
import FormEdit from "../Components/FormEdit";
import { NavbarWithoutLogo } from "../Components/Navbar";

export default function EditData() {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getProperty = async () => {
      const response = await fetch(
        `https://kjpp-server.vercel.app/api/properties/${id}`
      );
      const json = await response.json();

      setData(json);
      setLoading(false);
    };
    getProperty();
  }, [id]);

  return (
    <div className="bg-[#F2F4F5] min-h-screen">
      <NavbarWithoutLogo label={"Edit data rumah"} />
      {loading && (
        <div className="h-screen w-full flex justify-center items-center">
          <Loading />
        </div>
      )}
      {!loading && (
        <div className="pt-20 pb-5 flex justify-center">
          <div className="w-full border border-black rounded-md p-5 max-w-screen-md bg-white">
            <h1 className="font-bold mb-5 text-xl">SPESIFIKASI</h1>
            <FormEdit data={data} />
          </div>
        </div>
      )}
    </div>
  );
}
